import { useEffect } from "react";

function setMetaName(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setMetaProperty(property: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export function useDocumentMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;
    setMetaName("description", description);
    if (keywords) {
      setMetaName("keywords", keywords);
    }
    setMetaProperty("og:title", title);
    setMetaProperty("og:description", description);
    setMetaName("twitter:title", title);
    setMetaName("twitter:description", description);
  }, [title, description, keywords]);
}